import Vue from 'vue'
import VueRouter from 'vue-router'
import { Views } from '@/views' // imports all Views from Views folder
import Home from "@/views/bootstrap/Home";

Vue.use(VueRouter)

let routes = [
    {
        path: '/',
        name: 'Main Page',
        component: Home
    },
]
routes = routes.concat(Views)

//console.log('Available Routes', routes)

const router = new VueRouter({
    base: '/',
    mode: 'history',
    routes
})




export default router